import { commonEnv } from "./environment.common";

export const environment = {
  production: true,
  env: "prod",
  appVersion: "0.9B",
  clientFolder: "CycleMashkantaClient",
  GAKey: "UA-71783710-7",//sky prod
  printGALogs: true, //print ga logs
  apiUri: 'https://sc.mizrahi-tefahot.co.il/TofesMashkantaWebAPI/api',
  chatUrl: 'https://vc.mizrahi-tefahot.co.il/floatingChatNGv2.aspx?profile={0}&lang=he&t={1}&url={2}7refer={3}&title={4}',
  leadleaves: true,
  common: { ...commonEnv }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts